import AsyncSelect from './async-select.vue';

export default AsyncSelect;
